import { Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import {
  API,
  entityTypes,
  fileUpload,
  metaTitle,
} from "../../../config";
import {
  getCustomerDetail,
  useStateList,
  useSuburbListE,
} from "./components/CustomerHelper";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Form from "./components/Form";
import Spin from "../../common/Spin";
import { AddCustomerSchema } from "../../common/Validation";
import {
  formatedPostalCode,
  formatName,
} from "../../common/Misc";
import TitleBar from "../../common/TitleBar";

const EditCustomer = () => {
  const navigate = useNavigate();
  const params = useParams();
  const businessId = params?.business_id;
  const [loading, setLoading] = useState(false);
  const [customerData, setCustomerData] = useState();
  const formValues = useRef();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const customerId = query.get("id");
  let existingValues = [];
  let overwrittenFields = [];

  useEffect(() => {
    async function fetchData() {
      try {
        // await getUsers();
        setLoading(true);
        const data = await getCustomerDetail(customerId);
        setCustomerData(data);
        setLoading(false);
      } catch (e) {
        setCustomerData(null);
      }
    }
    fetchData();
    window.document.title = `${metaTitle} | Edit Customer`
  }, [customerId]);

  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    value.phone = value?.phone ? `${value?.phone}`.replace(/ /g, "") : "";
    value.mobile = value?.mobile ? `${value?.mobile}`.replace(/ /g, "") : "";
    value.abn = value?.abn ? `${value?.abn}`.replace(/ /g, "") : "";
    value.entity_type = value?.entity_type?.value;
    value.contact_type = value?.contact_type?.value;

    value.state_id = value?.state_id?.value;
    value.suburb_id = value?.suburb_id?.value;

    value.shipping_state_id = value?.shipping_state_id?.value;
    value.shipping_suburb_id = value?.shipping_suburb_id?.value;

    formData.append("client_business_id", businessId);
    formData.append("first_name", value?.first_name ? value?.first_name : "");
    formData.append("last_name", value?.last_name ? value?.last_name : "");
    formData.append("display_name", value?.display_name ? value?.display_name : "");
    formData.append("phone", value?.phone ? value?.phone : "");
    formData.append("mobile", value?.mobile ? value?.mobile : "");
    formData.append("email", value?.email ? value?.email : "");
    formData.append(
      "business_name",
      value?.business_name ? value?.business_name : ""
    );
    formData.append(
      "ref_number",
      value?.ref_number ? value?.ref_number : ""
    );
    formData.append(
      "bpay_ref_number",
      value?.bpay_ref_number ? value?.bpay_ref_number : ""
    );
    formData.append(
      "entity_type",
      value?.entity_type ? value?.entity_type : ""
    );
    formData.append("abn", value?.abn ? value?.abn : "");
    formData.append("contact_type", value?.contact_type);
    formData.append("_method", "put");
    formData.append("street", value?.street ? value?.street : "");
    formData.append("state_id", value?.state_id ? value?.state_id : "");
    formData.append("suburb_id", value?.suburb_id ? value?.suburb_id : "");
    formData.append(
      "postal_code",
      value?.postal_code ? value?.postal_code : ""
    );
    formData.append(
      "shipping_street",
      value?.shipping_street ? value?.shipping_street : ""
    );
    formData.append(
      "shipping_state_id",
      value?.shipping_state_id ? value?.shipping_state_id : ""
    );
    formData.append(
      "shipping_suburb_id",
      value?.shipping_suburb_id ? value?.shipping_suburb_id : ""
    );
    formData.append(
      "shipping_postal_code",
      value?.shipping_postal_code ? value?.shipping_postal_code : ""
    );

    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.CUSTOMER_Add}/${customerId}`,
        formData
      );
      setLoading(false);
      if (data) {
        toast.success(data?.message);
        navigate("/business/" + businessId + "/customers");
      }
      return data?.data;
    } catch (error) {
      setCustomerData(value);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  // State
  const { stateLoading, stateList = [] } = useStateList();
  const stateListing = stateList?.map((item) => {
    const { name: label, id: value, ...rest } = item;
    return { label, value, ...rest };
  });
  const state = stateListing?.find(
    (item) => item?.value === customerData?.state_id
  );

  //ShippingState
  const shippingState = stateListing?.find(
    (item) => item?.value === customerData?.shipping_state_id
  );

  // Suburb
  const { suburbLoading, suburbList = [] } = useSuburbListE(
    customerData?.state_id
  );
  const suburbListing = suburbList?.map((item) => {
    const { name: label, id: value, ...rest } = item;
    return { label, value, ...rest };
  });
  const suburb = suburbListing?.find(
    (item) => item?.value === customerData?.suburb_id
  );

  // ShippingSuburb
  const { suburbLoading2, shippingSuburbList = [] } = useSuburbListE(
    customerData?.shipping_state_id
  );
  const shippingSuburbListing = shippingSuburbList?.map((item) => {
    const { name: label, id: value, ...rest } = item;
    return { label, value, ...rest };
  });
  const shippingSuburb = shippingSuburbListing?.find(
    (item) => item?.value === customerData?.shipping_suburb_id
  );

  const ContactTypeListing = [
    { label: "Customer", value: 1 },
    { label: "Supplier", value: 2 },
    { label: "Contractor", value: 3 },
  ];

  const contactType = ContactTypeListing?.find(
    (item) => item?.value === parseInt(customerData?.contact_type)
  );

  return (
    <div className="cms-page">
      <div className="page-content-block">
        <div className="full-content-block">
          <TitleBar 
            label={formatName(customerData?.first_name, customerData?.last_name)}
          />
          <div className="content-details">
            <section>
              <Formik
                initialValues={{
                  first_name: customerData?.first_name,
                  last_name: customerData?.last_name,
                  display_name: customerData?.display_name,
                  phone: customerData?.phone,
                  mobile: customerData?.mobile,
                  email: customerData?.email,
                  business_name: customerData?.business_name,
                  ref_number: customerData?.ref_number,
                  bpay_ref_number: customerData?.bpay_ref_number,
                  abn: customerData?.abn,
                  entity_type: entityTypes?.find(
                    (item) => item?.value === customerData?.entity_type
                  ),
                  contact_type: contactType,

                  street: customerData?.street,
                  state_id: state,
                  suburb_id: suburb,
                  postal_code: formatedPostalCode(customerData?.postal_code),

                  same_address: false,

                  shipping_street: customerData?.shipping_street,
                  shipping_state_id: shippingState,
                  shipping_suburb_id: shippingSuburb,
                  shipping_postal_code: formatedPostalCode(
                    customerData?.shipping_postal_code
                  ),
                }}
                enableReinitialize
                innerRef={formValues}
                onSubmit={handleFormSubmit}
                validateOnBlur={true}
                validateOnChange={true}
                validationSchema={AddCustomerSchema}
              >
                {({
                  values,
                  setErrors,
                  errors,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                }) => {
                  return (
                    <>
                      {loading && <Spin />}
                      <Form
                        values={values}
                        errors={errors}
                        setErrors={setErrors}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        handleSubmit={handleSubmit}
                        setFieldValue={setFieldValue}
                        formValues={formValues}
                        overwrittenFields={overwrittenFields}
                        existingValues={existingValues}
                        stateListing={stateListing}
                        stateLoading={stateLoading}
                        suburbListing={suburbListing}
                        shippingSuburbListing={shippingSuburbListing}
                        suburbLoadingE={suburbLoading}
                        suburbLoading2E={suburbLoading2}
                        ContactTypeListing={ContactTypeListing}
                      />
                    </>
                  );
                }}
              </Formik>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCustomer;
